import React, { useContext, useEffect, useState } from 'react';
import '../Default.css';
import './Mapa.css'
import { MapContainer, TileLayer, Marker, Popup, LayersControl, LayerGroup } from 'react-leaflet'
import type City from "../places/placesType"
import {
  Link
} from 'react-router-dom'
import places_file from "../places/places.json"
import { dynamicPositionStore } from './dynamicPositionStore';
import { PlayerLayer } from './PlayersLayer';
import L from 'leaflet';
import "leaflet-easybutton/src/easy-button.js";
import "leaflet-easybutton/src/easy-button.css";
import { AuthProvider } from '../globalContext';
import { RangeLayer } from './RangeLayer';
import { SelfLayer } from './SelfLayer';
import { HistoryLayer } from './HistoryLayer';

const cities: City[] = places_file as any;

export const rangeID = "range"

const defaultPosition : [number, number] = [41.403823007867295, 2.1744094405567873]
const defaultZoom: number = 14

function Mapa(props : any) {
    // TODO: do somethign with default locaiton
    const [map, setMap] = useState<L.Map|null>((null));
    const {id:userId} = useContext(AuthProvider)

    // localize player
    const params = new URLSearchParams(window.location.search)
    const player = params.get("userId")

    const useParam = player && dynamicPositionStore.getPlayerCord(player)

    //@ts-ignore
    const zoomLevel = window._zoom ?? defaultZoom

    const playerId = useParam ? player : userId
    const startPosition = dynamicPositionStore.getPlayerCord(playerId)?.coords ?? defaultPosition
    dynamicPositionStore.bindTo(playerId, rangeID)

    function handleFindMe(){
      let position = dynamicPositionStore.getPlayerCord(userId);
      if(position){
        map?.setView(position.coords)
      }
    }

    useEffect(()=>{
      if(!map) return;

      dynamicPositionStore.setup();

      if(!useParam){
        map.locate().on('locationfound', (e)=>{
          map.setView(e.latlng, map.getZoom())
        })
      }

      map.on('zoom', (e)=>{
        //@ts-ignore
        window._zoom = map.getZoom(); //save for app lifetime
      })

      // TODO: set icon & styling for that
      const button = L.easyButton('<img class="findButton" src="/icons/location-dot-solid.svg">', handleFindMe);
      button.addTo(map)
      
      return ()=>{
        button.remove()
      }
    },[map])

    return (
      // TODO: select player to zoom to + handle error no data (alert)
      <MapContainer ref={setMap} center={startPosition} zoom={zoomLevel}  scrollWheelZoom={false} style={{width:"100vw", height:`calc(100vh - 60px)`}}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          crossOrigin={true}
        />
        <LayersControl position='topright'>
          <LayersControl.Overlay checked name='Dokładność'>
                  <RangeLayer></RangeLayer>
            </LayersControl.Overlay>

          <LayersControl.Overlay checked name='Punkty'>
            <LayerGroup>
              {cities.map((elem, city_index) => <div key={city_index}>
                {elem.places.map((entry, place_index) => 
                  <Marker position={entry.location.pos} key={`${city_index}-${place_index}`}>
                    <Popup>
                      <Link to={`/places/${city_index}/${place_index}`}> {entry.name} </Link>
                    </Popup>
                  </Marker>
                )}</div>
              )}
              </LayerGroup>
            </LayersControl.Overlay>

            <LayersControl.Overlay checked name='Ludzie'>
                  <PlayerLayer/>
            </LayersControl.Overlay>

            <LayersControl.Overlay checked name='Ja'>
              <SelfLayer></SelfLayer>
            </LayersControl.Overlay>
            
          </LayersControl>
      </MapContainer>
    );

}

export default Mapa;